import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, switchMap, takeUntil } from 'rxjs';
import { BpService } from '../../../../core/services/bp.service';
import {
  BpRegistrationBySmsFormKeys,
  BpSmsCodeForm,
  BpVerifyBySmsForm, BpVerifyBySmsRequest,
} from './registration-by-sms.model';
import { RegistrationTypes } from '../register-organization/register-organization.model';
import { AuthApiService } from '../../../../core/modules/auth/auth-api.service';

@Component({
  selector: 'tax-registration-by-sms',
  templateUrl: 'registration-by-sms.component.html',
  styleUrls: [],
})

export class RegistrationBySmsComponent implements OnInit, OnDestroy {
  readonly bpRegistrationBySmsFormKeys = BpRegistrationBySmsFormKeys;

  processForm?: BpVerifyBySmsForm | BpSmsCodeForm;
  showSuccessWindow = false;
  userInfo?: BpVerifyBySmsRequest;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private authApiService: AuthApiService,
    private bpService: BpService,
  ) {}

  ngOnInit(): void {
    this.startBp();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  proceedRegistration(): void {
    const { pid, tid } = this.bpService.getProcessIds();
    this.router.navigate(
      ['/landing/registration/fill-form/'],
      {
        queryParams: {
          pid, tid, registrationType: RegistrationTypes.SMS,
        },
      },
    );
  }

  goToFirstStep(): void {
    this.startBp();
  }

  goToSmsConfirmStep(userInfo: BpVerifyBySmsRequest): void {
    this.userInfo = userInfo;

    this.bpService.submitAndGetForm<BpSmsCodeForm>(userInfo)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (processForm) => {
          this.processForm = processForm;
        },
      );
  }

  private startBp(): void {
    this.authApiService.getAnonymousUser()
      .pipe(
        switchMap(() => this.bpService.startBpAndGetData('create-user-short', {})),
        switchMap(() => this.bpService.submitAndGetForm<BpVerifyBySmsForm>({
          verifyBySms: true,
        })),
        takeUntil(this.destroy$),
      )
      .subscribe((process) => {
        this.processForm = process;
      });
  }
}
